import { AbstractClone } from "../../abstract/clone.abstract";
import { Injectable, Injector } from "@angular/core";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { CloneService } from "./clone.service";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { WidgetsQuestionModel } from "src/app/models/widgets/widgets-question.model";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";

@Injectable({
    providedIn: 'root'
})
export class CloneQuestionService extends AbstractClone {

    constructor(private injector: Injector) {
        super();
    }

    cloneFromJS(origWidget: any,
        parentWidget: WidgetsAbstract,
        isDragNDrop: boolean,
        isInsideQuestion: boolean,
        parentId: string | undefined) {
        let origQuestion: WidgetsQuestionModel = origWidget as WidgetsQuestionModel;
        const parentContainer = parentWidget as WidgetsContainerAbstract;

        // Retrieve from injector to avoid circular dependency
        const widgetsCloneService = this.injector.get(CloneService);

        if (!isDragNDrop) {
            // JSON to TypeScript question
            if (parentWidget instanceof WidgetsQuestionModel) {
                // Cloning question into question library. Parent widget is a Question!
                const newQuestion: WidgetsQuestionModel = parentWidget as WidgetsQuestionModel;
                newQuestion.cloneFrom(origQuestion);
                newQuestion.parentId = parentId;        // This was not here...                               
                CloneService.cloneLabelOverrides(origQuestion, newQuestion);
                origQuestion?.children?.forEach(childWidget => {
                    widgetsCloneService.cloneFromJS(childWidget, newQuestion, false, isInsideQuestion, newQuestion.id);
                });
            } else {
                // Cloning question into section. Parent widget is a Section
                const newQuestion: WidgetsQuestionModel = new WidgetsQuestionModel;                
                newQuestion.cloneFrom(origQuestion);
                newQuestion.parentId = parentId;                 
                CloneService.cloneLabelOverrides(origQuestion, newQuestion);                
                parentContainer.children.push(newQuestion);                    
                origQuestion?.children?.forEach(childWidget => {
                    widgetsCloneService.cloneFromJS(childWidget, newQuestion, false, isInsideQuestion, newQuestion.id);
                });
            }
        } else {
            // Question dropped into Container: Clone from library question TypeScript to layout TypeScript
            const newQuestion: WidgetsQuestionModel = parentWidget as WidgetsQuestionModel;
            newQuestion.parentId = parentId;
            newQuestion.cloneFrom(origQuestion);
            CloneService.cloneLabelOverrides(origQuestion, newQuestion);
            origQuestion?.children?.forEach(childWidget => {
                widgetsCloneService.cloneFromJS(childWidget, parentWidget!, false, isInsideQuestion, newQuestion.id);
            });
        }

    }
}
